@if (!emptyText() || result()) {
  @for (part of parts(); track part; let isOdd = $odd) {
    @if (isOdd) {
      <span [class]="highlightClass()">{{ part }}</span>
    } @else {
      <span>{{ part }}</span>
    }
  }
} @else {
  <span class="text-muted">{{ emptyText() }}</span>
}
